import { Empty } from "antd";
import ListTable from "common/ListTable";

const FinishingHourlyIronOriginalTable = (props) => {
  const { total, loading, defaultCurrent, pageSize, current, onChange, emptyHint } = props;

  return (
    <>
      <div className="table" style={{ marginTop: 10 }}>
        <ListTable
          loading={loading}
          pagination={{
            showSizeChanger: false,
            defaultPageSize: pageSize,
            current: current,
            onChange: onChange,
            defaultCurrent: defaultCurrent,
            total: total,
          }}
          columns={props.tableColumns}
          dataSource={props.dataSource}
          // ux2(C1): A3 empty-state hint so a blank table never reads as "you forgot to filter".
          locale={emptyHint ? { emptyText: <Empty description={emptyHint} /> } : undefined}
          // scroll={{ x: "max-content" }}
        />
      </div>
    </>
  );
};
export default FinishingHourlyIronOriginalTable;
